var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('slider',{ref:"slider",attrs:{"options":_vm.options}},_vm._l((_vm.slides),function(item,index){return _c('slideritem',{key:index,style:(item.style)},[_c('a',{attrs:{"href":item.url_link !== null ? item.url_link : '',"target":item.url_link !== null ? '_blank' : ''}},[_c('img',{attrs:{"src":`${item.path}`}})])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }